import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { permissions } from '../../permissions';
import { TradingPartnersComponent } from './trading-partners.component';
import { AuthGuardService as AuthGuard } from './../../auth-guard.service';
import { TpNewCustomerComponent } from './tp-new-customer/tp-new-customer.component';
import { TpNewVendorComponent } from './tp-new-vendor/tp-new-vendor.component';

export const routes: Routes = [
  {
    path: 'trading-partners',
    component: TradingPartnersComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Trading Partners',
      permissions: {
        only: [permissions.EDI_MAINT_EDIT, permissions.EDI_MAINT_VIEW],
      },
    },
  },
  {
    path: 'trading-partners/add-customer/:id/:CO1_ID',
    component: TpNewCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Add Trading Partner: Customer',
      permissions: {
        only: [permissions.EDI_MAINT_EDIT, permissions.EDI_MAINT_VIEW],
      },
    },
  },
  {
    path: 'trading-partners/add-vendor/:id/:CO1_ID',
    component: TpNewVendorComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Add Trading Partner: Vendor',
      permissions: {
        only: [permissions.EDI_MAINT_EDIT, permissions.EDI_MAINT_VIEW],
      },
    },
  },
  {
    path: 'trading-partners/edit-vendor/:hash',
    component: TpNewVendorComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Trading Partner: Vendor View',
      permissions: {
        only: [
          permissions.EDI_MAINT_EDIT,
          permissions.EDI_MAINT_VIEW,
          permissions.EDI_MAINT_EDIT_TOKEN,
        ],
      },
    },
  },
  {
    path: 'trading-partners/edit-vendor/:id/:CO1_ID',
    component: TpNewVendorComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Trading Partner: Vendor View',
      permissions: {
        only: [permissions.EDI_MAINT_EDIT, permissions.EDI_MAINT_VIEW],
      },
    },
  },
  {
    path: 'trading-partners/edit-customer/:hash',
    component: TpNewCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Trading Partner: Customer View',
      permissions: {
        only: [
          permissions.EDI_MAINT_EDIT,
          permissions.EDI_MAINT_VIEW,
          permissions.EDI_MAINT_EDIT_TOKEN,
        ],
      },
    },
  },
  {
    path: 'trading-partners/edit-customer/:id/:CO1_ID',
    component: TpNewCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Trading Partner: Customer View',
      permissions: {
        only: [permissions.EDI_MAINT_EDIT, permissions.EDI_MAINT_VIEW],
      },
    },
  },
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/trading-partners/trading-partners.routing.ts